import styled from 'styled-components';
import useReduxReducer from '../../../hooks/useReduxReducer';
import stats from './reducers';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import React, { Fragment, useEffect } from 'react';
import { getClosureStatsAction } from './actions';
import { FormattedDate, FormattedNumber } from 'react-intl';

const basicData = [
  { label: 'Společnost', value: 'Taneční studio Stolárna s.r.o.' },
  { label: 'Adresa', value: 'Růženec 652/48, Soběšice, 644 00 Brno' },
  { label: 'IČ', value: '01784285' },
  { label: 'DIČ', value: 'CZ01784285' },
];

const ClosurePrint = () => {
  useReduxReducer({ stats });
  let { id: closureId } = useParams();
  const dispatch = useDispatch();
  const statistics = useSelector((state) => state?.stats?.statistics?.data);

  useEffect(() => {
    dispatch(getClosureStatsAction(closureId));
  }, [closureId, dispatch]);

  console.log(statistics);

  const statsHeader = statistics?.closure;
  const date = statsHeader ? new Date(statsHeader?.createdOn) : new Date();
  const closureDate = new Date(date.setDate(date.getDate() - 1));

  return (
    <PageContainer>
      <h3>Denní tržba</h3>
      <TopRow>
        <BorderDiv>
          <InfoTable data={basicData} />
        </BorderDiv>
        <BorderDiv>
          <InfoTable
            data={[
              { label: 'Datum', value: <FormattedDate value={closureDate} /> },
              { label: 'Počet účtenek', value: statsHeader?.transactionCount },
              { label: 'DPH', value: <FormattedNumber value={statsHeader?.taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} /> },
              {
                label: 'Celkem bez DPH',
                value: <FormattedNumber value={statsHeader?.grossAmount - statsHeader?.taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />,
              },
              { label: 'Celkem s DPH', value: <FormattedNumber value={statsHeader?.grossAmount || 0} currency={'CZK'} {...{ style: 'currency' }} /> },
            ]}
          />
        </BorderDiv>
      </TopRow>
      <h3>DPH</h3>
      <VatTable
        vatGroups={
          statistics?.vatStatisticsByGroup
            ? [
                ...statistics.vatStatisticsByGroup,
                {
                  name: 'celkem',
                  lines: statistics.vatStatistics,
                },
              ]
            : []
        }
      />
    </PageContainer>
  );
};

export default ClosurePrint;

const PageContainer = styled.div`
  padding: 5px;
`;
const TopRow = styled.div`
  display: flex;
  gap: 50px;
`;

const BorderDiv = styled.div`
  flex: 1;
  border: 1px solid black;
  padding: 10px;
`;

const InfoTable = ({ data }) => {
  return (
    <table style={{ fontSize: '0.6em' }}>
      <tbody>
        {data.map((row, index) => {
          return (
            <tr key={index}>
              <td style={{ fontWeight: 'bold', paddingRight: '30px' }}>{row.label}:</td>
              <td>{row.value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const VatTable = ({ vatGroups }) => {
  return (
    <StyledTable>
      <thead>
        <tr>
          <StyledTh>sazba</StyledTh>
          <StyledTh>základ DPH</StyledTh>
          <StyledTh>DPH</StyledTh>
          <StyledTh>celkem</StyledTh>
        </tr>
      </thead>
      <tbody>
        {vatGroups?.map((group, index) => {
          return (
            <Fragment key={index}>
              <tr>
                <td colSpan={4} style={{ borderTop: '1px solid black', borderBottom: '1px solid black', padding: '0 10px', fontWeight: 'bold' }}>
                  {group.name}
                </td>
              </tr>
              {group?.lines.map((line, index) => {
                return (
                  <tr key={index}>
                    <StyledTd>
                      <FormattedNumber value={line.percentage / 100 || 0} {...{ style: 'percent' }} />
                    </StyledTd>
                    <StyledTd>
                      <FormattedNumber value={line.grossAmount - line.taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
                    </StyledTd>
                    <StyledTd>
                      <FormattedNumber value={line.taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
                    </StyledTd>
                    <StyledTd>
                      <FormattedNumber value={line.grossAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
                    </StyledTd>
                  </tr>
                );
              })}
            </Fragment>
          );
        })}
      </tbody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  width: 100%;
  border: 1px solid #ccc;
  font-size: 0.8em;
`;

const StyledTh = styled.th`
  border-bottom: 1px solid black;
  border-top: 1px solid black;
  text-align: right;
  font-weight: bold;
  padding: 0 10px;
`;

const StyledTd = styled.td`
  text-align: right;
  padding: 0 10px;
`;
